<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    created() {
      this.$store.dispatch("changeBaseUrl", window.location.origin);

      this.setLocale();
    },

    methods: {
      setLocale() {
        if (this.$route.params.locale == "en") {
          this.$i18n.locale = "en";
        } else if (this.$route.params.locale == "ru") {
          this.$i18n.locale = "ru";
        } else {
          this.$router.push("/ru");
        }
      }
    },
    watch: {
      $route() {
        this.setLocale();
      }
    }
  };
</script>

<style lang="scss" scoped></style>
